import React, { useState } from "react";
import Input from "../../components/inputs/Input";
import Button from "../../components/buttons/Button";
import Text from "../../components/typography/Text";
import Checkbox from "../../components/checkboxes/Checkbox";

export default ({ data, setData, errors, setError, next, btnLabel, saved }) => {
	const [saveError, setSaveError] = useState();
	const isDesigner = data?.["role"] === "designer";

	const verifyData = async () => {
		setError();
		setSaveError(null);
		let isOkay = true;
		if (!data["email"] || !/.+@.+\..{2,3}/.test(data["email"])) {
			setError({ field: "email", message: "Please provide a correct email" });
			isOkay = false;
		}
		if (data["password"] && !data["password_old"]) {
			setError({
				field: "password",
				message: "Please provide your current password to change it",
			});
			isOkay = false;
		}
		if (data["password"] && data["password"].length < 8) {
			setError({
				field: "password",
				message: "Please provide a password with min. 8 chars.",
			});
			isOkay = false;
		}
		if (data["password"] !== data["password_verify"]) {
			setError({ field: "password_verify", message: "Passwords mismatch" });
			isOkay = false;
		}
		if (isOkay) {
			try {
				await next();
			} catch (err) {
				console.error(err);
				setSaveError(err);
			}
		}
	};

	return (
		<div className="oUserForm">
			<h3>Account</h3>
			<div className="oUserForm_inputs">
				<Input
					label="Email"
					required
					value={data["email"]}
					setValue={(value) => setData({ field: "email", value })}
					error={errors.some(({ field }) => field === "email")}
					type="email"
				/>
				<Input
					label="Password"
					type="password"
					required
					value={data["password_old"]}
					setValue={(value) => setData({ field: "password_old", value })}
					error={errors.some(({ field }) => field === "password_old")}
				/>
				<Input
					label="New password"
					type="password"
					value={data["password"]}
					setValue={(value) => setData({ field: "password", value })}
					error={errors.some(({ field }) => field === "password")}
				/>
				<Input
					label="Verify password"
					type="password"
					required
					value={data["password_verify"]}
					setValue={(value) => setData({ field: "password_verify", value })}
					error={errors.some(({ field }) => field === "password_verify")}
				/>

				{isDesigner && (
					<Checkbox
						// eslint-disable-next-line
						checked={data["notification_enabled"] == true}
						setValue={() =>
							setData({
								field: "notification_enabled",
								// eslint-disable-next-line
								value: data["notification_enabled"] == true ? "0" : "1",
							})
						}
						labelComponent={
							<Text small black>
								I want to receive email notification on new matching jobs.
							</Text>
						}
					/>
				)}
			</div>
			{saveError && (
				<Text error small>
					An error occured. Please retry later or contact support.
				</Text>
			)}
			{saved ? (
				<Button big green full>
					Saved !
				</Button>
			) : (
				<Button onClick={verifyData} big full>
					{btnLabel || "Continue"}
				</Button>
			)}
		</div>
	);
};
